import { render } from "./djylResourceNew.vue?vue&type=template&id=4f72dfbb&scoped=true"
import script from "./djylResourceNew.vue?vue&type=script&lang=js"
export * from "./djylResourceNew.vue?vue&type=script&lang=js"

import "./djylResourceNew.vue?vue&type=style&index=0&id=4f72dfbb&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f72dfbb"]])

export default __exports__